"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastWrapper = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
require("@itwin/itwinui-css/css/toast.css");
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Toast_js_1 = __importDefault(require("./Toast.js"));
exports.ToastWrapper = React.forwardRef((_, ref) => {
    const [toasts, setToasts] = React.useState([]);
    const [placement, setPlacement] = React.useState('top');
    const placementPosition = placement.startsWith('top') ? 'top' : 'bottom';
    React.useImperativeHandle(ref, () => ({
        setToasts,
        setPlacement,
    }), []);
    return (React.createElement("span", { className: (0, classnames_1.default)(`iui-toast-wrapper`, `iui-placement-${placement}`) }, toasts.map((toastProps) => {
        return (React.createElement(Toast_js_1.default, { key: toastProps.id, placementPosition: placementPosition, ...toastProps }));
    })));
});
